export const SET_TRIAL_BALANCE_FILTER = 'SET_TRIAL_BALANCE_FILTER';
export const UNSET_TRIAL_BALANCE_FILTER = 'UNSET_TRIAL_BALANCE_FILTER';
export const UPLOAD_TRIAL_BALANCE_FILE = 'UPLOAD_TRIAL_BALANCE_FILE';
